export type Validator = (fieldValues: string | string[] | boolean | undefined, formValues: (string | string[] | boolean)[]) => string | undefined;

export const noValidation: Validator = () => undefined;
